import React from "react";
import { View, Text } from "react-native";
import { userBranchName, userProfileSelector } from "@/app/selectors/user";
import { useSelector } from "react-redux";
import { headerStyles as styles } from "./styles";
import { useTranslateText } from "@/app/utils/translations";
import PrintSettings from "./PrintSettings";
import TposButton from "@/app/components/Buttons/TposButton";
import { TposIcon } from "@/app/components/Icons/TposIcon";
import logout from "@/assets/logout.png";

type HeaderProps = {
  onLogoutPress: () => void;
};

const Header = ({ onLogoutPress }: HeaderProps) => {
  const userData = useSelector(userProfileSelector);
  const branchName = useSelector(userBranchName);
  const fullName = userData
    ? `${userData?.firstName} ${userData?.lastName}`
    : "";
  const { t } = useTranslateText();

  return (
    <View style={styles.container}>
      <Text
        accessible
        accessibilityLabel={"Profile Branch Name"}
        accessibilityRole="text"
        style={styles.branchHeader}
      >
        {branchName}
      </Text>
      <PrintSettings />
      <View style={styles.bottomContainer}>
        <Text style={styles.userText}>{fullName}</Text>
        <View style={styles.logoutButtonContainer}>
          <TposButton
            styles={{
              buttonContainer: styles.logoutButton,
            }}
            onPress={onLogoutPress}
            disabled={false}
            buttonText={t("profileScreen.signOut")}
          >
            <TposIcon icon={logout} />
          </TposButton>
        </View>
      </View>
    </View>
  );
};

export default Header;
